import { useSyncExternalStore } from 'react'

const subscribe = (callback: () => void) => {
    const observer = new MutationObserver(callback)
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme'],
    })
    return () => observer.disconnect()
}

const getSnapshot = () =>
    document.documentElement.getAttribute('data-theme') || 'light'

const getServerSnapshot = () => 'light'

export const useThemeAttribute = () =>
    useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
